module.exports = __webpack_public_path__ + "img/0Q3A3001_L_Black_MockedUp.d625b123.jpg";